// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BBBRecord
 */
export interface BBBRecord {
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    recordId?: string;
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    meetingId?: string;
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BBBRecord
     */
    isPublished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    state?: BBBRecordStateEnum;
    /**
     * 
     * @type {Date}
     * @memberof BBBRecord
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BBBRecord
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    playbackType?: string;
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    playbackUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof BBBRecord
     */
    playbackLength?: number;
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    deskShareVideoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    webcamVideoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof BBBRecord
     */
    downloadUrl?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BBBRecordStateEnum {
    Processing = 'processing',
    Processed = 'processed',
    Published = 'published',
    Unpublished = 'unpublished',
    Deleted = 'deleted'
}



